import classnames from 'classnames';
import { Button } from 'components/atoms';
import { ParrallaxContainer } from 'components/molecules/ParrallaxBlock';
import React, { FC, useEffect } from 'react';
import { Background } from 'react-parallax';
import { getAssetPath, getAssetPathByHeight, useDeviceClassification, valueParser } from 'utils';
import styles from "../ContentBlocks.module.css";
import uuid from "react-uuid";
import $ from "jquery";
import classNames from 'classnames';
import { motion } from 'framer-motion';
import { TextEditor } from 'components/molecules/TextEditor';


const _FullWidthPromoTextBlock = ({
    ...props
}) => {
    const boxed = Boolean(props.DescriptionOverlayBackgroundColour);

    useEffect(() => {
        boxed ?
            $('.FullWidthPromoTextBlock .postcontent *').css({ color: props.DescriptionTextColour.Value ? `${props.DescriptionTextColour.Value}` : '#353d30' })
            :
            $('.FullWidthPromoTextBlock .postcontent *').css({ color: '#EFF0EF' })
        $('.FullWidthPromoTextBlock  a').css({ color: props.DescriptionTextColour.Value ? `${props.DescriptionTextColour.Value}` : '#353d30' })
    })

    const { isMobile, isTablet, isDesktop } = useDeviceClassification();

    // Dynamically determine the best video based on device width.
    const determineBestVideo = () => {
        if (isMobile) {
            return props.BackgroundVideoMobile || props.BackgroundVideoTablet || props.BackgroundVideoDesktop
        } else if (isTablet) {
            return props.BackgroundVideoTablet || props.BackgroundVideoDesktop;
        } else {
            return props.BackgroundVideoDesktop
        }
    };

    const mp4 = determineBestVideo()?.MediaUrl;
    const blockLink = props.BlockLinkText;

    // Dynamically determine best block image based on device width.
    const determineBestBlockImage = () => {
        if (isMobile) {
            return { Src: valueParser(props.BlockImageMobile?.Src) || valueParser(props.BlockImageTablet?.Src), Alt: valueParser(props.BlockImageMobile?.Alt) || valueParser(props.BlockImageTablet?.Alt) }
        } else if (isTablet) {
            return { Src: valueParser(props.BlockImageTablet?.Src) || valueParser(props.BlockImageDesktop?.Src), Alt: valueParser(props.BlockImageTablet?.Alt) || valueParser(props.BlockImageDesktop?.Alt) }
        } else {
            return { Src: valueParser(props.BlockImageDesktop?.Src), Alt: valueParser(props.BlockImageDesktop?.Alt) }
        }
    };

    // Dynamically determine block height based on device width.
    const determineBlockHeight = () => {
        if (isMobile) {
            return props.MinimumBlockHeightMobile
        } else if (isTablet) {
            return props.MinimumBlockHeightTablet
        } else {
            return props.MinimumBlockHeightDesktop
        }
    };

    const { Src, Alt } = determineBestBlockImage();
    const height = determineBlockHeight();

    return (
        <div>
            <div className="slide-down FullWidthPromoTextBlock">
                <ParrallaxContainer
                    height={`${window.innerHeight / 10 * (height / 10)}px`}
                    className={`FullWidthPromoTextBlock-${uuid()}`}
                    type={'FullWidthPromoTextBlock'}
                >

                    {mp4 && <Background className="custom-bg">
                        <video
                            className={'parralaxVideo'}
                            autoPlay={true}
                            loop={true}
                            muted
                        >
                            <source src={getAssetPath(mp4)} type="video/mp4" />
                        </video>
                    </Background>}
                    {
                        !mp4 && <Background className="custom-bg">
                            <img src={getAssetPathByHeight(Src, Math.floor(window.innerHeight / 10 * (height / 10)))} alt={Alt} />
                        </Background>
                    }

                    <>
                        <div
                            className={classnames(styles.ImageBlock_TextWrapper)}
                        >
                            <div className={`contentWrapper ${props.DescriptionOverlayAlignment.Class}`}>
                                <div className={classNames("textBox", "animateonscroll", { boxed: boxed })} style={{
                                    width: isDesktop ? `calc((100% / 12 * ${props.DescriptionOverlayColumn}) + ((40px / 12 * ${props.DescriptionOverlayColumn} - 40px)))` : `100%`,
                                    background: boxed ? props.DescriptionOverlayBackgroundColour.Value : ''
                                }}>
                                    <TextEditor className="postcontent c-block mb-30"
                                        data={props.Description }
                                    />

                                    {blockLink &&
                                        <>
                                            {boxed && Boolean(props.BlockLink?.Url.length) &&
                                                <Button className={'noPadding autoH'} as="button" buttonStyle='chevron'>
                                                    <motion.a
                                                        target={props.BlockLink.Target}
                                                        whileHover={{
                                                            color: '#84bd00', transition: {
                                                                duration: .1
                                                            }
                                                        }}
                                                        href={props.BlockLink.Url}>
                                                        {blockLink}
                                                    </motion.a>
                                                </Button>
                                            }

                                            {!boxed && Boolean(props.BlockLink?.Url.length) && <Button
                                                target={props.BlockLink.Target}
                                                buttonStyle="g-ol"
                                                href={props.BlockLink.Url}
                                                as={'a'}>
                                                {blockLink}
                                            </Button>}

                                        </>
                                    }
                                </div>
                            </div>
                        </div>
                    </>
                </ParrallaxContainer>

            </div>
        </div>);
}

export const FullWidthPromoTextBlock = React.memo(_FullWidthPromoTextBlock);
